export default __webpack_public_path__ + "static/media/image8.4abc17a2.jpg";